import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { LinkButton } from './buttons/link/LinkButton'
import { BodySmall, Title4, Title6 } from './styles/Typography'
import { theme } from '../theme/theme'
import { useIsFeatureEnabled } from '../state/selectors'
import { FeatureFlagId } from '../api/ester-b2b-api/private/featureFlags/types'
import { Stethoscope } from './icons'
import { ComponentLayout } from './layouts/ComponentLayout'

const CARE_INBOX_IMAGE_URL =
  'https://images.ctfassets.net/hr4hxqu06b00/3j1TJNFBO1DYmNBieGT2zr/a72ac06cf039f7785f2432279fa929c2/image.png'

export const MessageSection = () => {
  const { t } = useTranslation()
  const isChatEnabled = useIsFeatureEnabled(FeatureFlagId.USE_PORTAL_CHAT)

  if (!isChatEnabled) return null

  return (
    <ComponentLayout paddingTop={theme.spacing.xxlarge}>
      <QuestionLabel>{t('employee.home.messageQuestion')}</QuestionLabel>
      <CardBackground>
        <CardContent>
          <TextContent>
            <TitleRow>
              <IconWrapper>
                <Stethoscope size={24} color={theme.color.plum} />
              </IconWrapper>
              <Title4>{t('employee.home.messageTitle')}</Title4>
            </TitleRow>
            <BodySmall>{t('employee.home.messageDescription')}</BodySmall>
            <ButtonWrapper>
              <LinkButton href="/portal/messages/new" text={t('employee.yourHealth.askUsCta')} secondary />
            </ButtonWrapper>
          </TextContent>
          <ImageWrapper>
            <CareInboxImage src={CARE_INBOX_IMAGE_URL} alt="" />
          </ImageWrapper>
        </CardContent>
      </CardBackground>
    </ComponentLayout>
  )
}

const QuestionLabel = styled(Title6)`
  margin-bottom: ${theme.spacing.medium}px;
`

const CardBackground = styled.div`
  background-color: ${theme.color.beigeDark};
  border-radius: ${theme.spacing.medium}px;
  box-shadow:
    0px 1px 2px 0px rgba(0, 0, 0, 0.06),
    0px 3px 9px 0px rgba(0, 0, 0, 0.05);
  overflow: hidden;
`

const CardContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.mediumLarge}px;
  max-width: 1300px;
  padding: ${theme.spacing.large}px ${theme.spacing.mediumLarge}px;
  padding-bottom: 0;

  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    flex-direction: column;
    padding: ${theme.spacing.large}px;
  }
`

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.medium}px;
  max-width: 567px;
  padding-bottom: ${theme.spacing.large}px;
  color: ${theme.color.plum};
`

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.medium}px;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 100px;
  background-color: ${theme.color.white};
  flex-shrink: 0;
`

const ButtonWrapper = styled.div`
  width: fit-content;
`

const ImageWrapper = styled.div`
  flex-shrink: 0;
  align-self: flex-end;

  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    display: none;
  }
`

const CareInboxImage = styled.img`
  height: 220px;
  object-fit: contain;
  display: block;
`
